import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { EventCollisionMatch } from 'app/event/models/event-collision-match';
import { ModalDirective, ModalOptions } from 'ngx-bootstrap/modal';
import { User } from '../../auth/models/User';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { EventCollisionModalResponse } from '../event-collision-modal/event-collision-modal-response';
import { EventCollisionModalResponseEnum } from '../event-collision-modal/event-collision-modal-response.enum';

@Component({
  selector: 'pioneer-event-collision-modal-multiprompt',
  templateUrl: './event-collision-modal-multiprompt.component.html',
  styleUrls: ['./event-collision-modal-multiprompt.component.css']
})
export class EventCollisionModalMultipromptComponent implements OnInit {

  public EventCollisionModalResponse = EventCollisionModalResponse;

  public content;

  @Input()
  public eventMatch: EventCollisionMatch;

  @Input()
  public match: any | null = [];

  @Input()
  public config = {
    backdrop: 'static'
  } as ModalOptions;

  @Input()
  public user: User;

  @Input()
  public mode: string;

  @Output()
  public closed = new EventEmitter();

  @Output()
  public canceled = new EventEmitter();

  @ViewChild(ModalDirective)
  public confirmationModal: ModalDirective;

  response: EventCollisionModalResponse;

  selectedMatches: number[] = [];

  constructor(private authenticationStore: AuthenticationStore) { }

  ngOnInit() {
  }

  get isPropertyUser(): boolean {
    return this.authenticationStore.isPropertyUser();
  }

  get isShown(): boolean { return this.confirmationModal.isShown; }

  public open(eventMatch: EventCollisionMatch, match: any): void {
    this.response = undefined;
    this.eventMatch = eventMatch;
    this.match = match;
    this.content = 'EVENT_COLLISION.MODAL.MULTI.INSTRUCTION_TEXT';
    this.selectedMatches = [];
    match.forEach((item: any) => {
      this.selectedMatches.push(item.event_match_id);
    });
    this.confirmationModal.show();
  }

  mergeSelectedEvent() {
    this.response = new EventCollisionModalResponse({
      selectedButton: EventCollisionModalResponseEnum.MergeEvents,
      selectedMatches: this.selectedMatches
    });
    this.confirmationModal.hide();
  }

  doNotMerge() {
    this.selectedMatches = [];
    this.response = new EventCollisionModalResponse({
      selectedButton: EventCollisionModalResponseEnum.DoNotMergeEvents,
      selectedMatches: this.selectedMatches
    });
    this.confirmationModal.hide();
  }

  cancelEventMatching() {
    this.selectedMatches = [];
    this.response = new EventCollisionModalResponse({
      selectedButton: undefined,
      selectedMatches: this.selectedMatches
    });
    this.confirmationModal.hide();
  }

  changeSelection(event) {
    const value = Number(event.target.value);
    if (event.target.checked) {
      if (this.selectedMatches.indexOf(value) === -1) {
        this.selectedMatches.push(value);
      }
    } else {
      if (this.selectedMatches.indexOf(value) > -1) {
        const index = this.selectedMatches.indexOf(value);
        this.selectedMatches.splice(index, 1);
      }
    }
  }

  public completePropertyForEventMatched(match): string {
    let output = '';
    if (match.name && match.name.length > 0) {
      output = output  + '<strong>'  + match.name + '</strong><br>';
    }
    if (match.property_name && match.property_name.length > 0) {
      output = output  + match.property_name + '<br>';
    }
    if (match.property_address && match.property_address.length > 0) {
      output = output  + match.property_address + '<br>';
    }
    let myDate = null;
    if (match.start_date && match.start_date.length > 0) {
      myDate = new Date(Date.parse(match.start_date));
      output = output  + myDate.toLocaleDateString();
    }
    if (match.end_date && match.end_date.length > 0) {
      myDate = new Date(Date.parse(match.end_date));
      output = output  +  ' &minus; ' + myDate.toLocaleDateString();
    }

    return output;
  }

  onHide() {
    if (this.response.selectedButton === undefined) {
      this.canceled.emit(this.response);
    } else {
      this.closed.emit(this.response);
    }
  }

  get isModalForMultiprompt(): Observable<boolean> {
    return of(Boolean(this.match.length > 1));
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/event-collision-modal-multiprompt/event-collision-modal-multiprompt.component.ts